import { render, staticRenderFns } from "./wechat.vue?vue&type=template&id=55b15636&scoped=true"
import script from "./wechat.vue?vue&type=script&lang=ts"
export * from "./wechat.vue?vue&type=script&lang=ts"
import style0 from "./wechat.vue?vue&type=style&index=0&id=55b15636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b15636",
  null
  
)

export default component.exports